"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepNumber = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getSize = function getSize(p) {
  return p.device === 'mobile' ? 1.25 : 1.5;
};
var StepNumber = exports.StepNumber = _styledComponents["default"].div.withConfig({
  displayName: "styles__StepNumber",
  componentId: "sc-bjsda7-0"
})(["background:#333;border-radius:50%;box-shadow:0 0 0 2px #fff;color:#fff;height:", "rem;line-height:", "rem;position:absolute;right:1rem;text-align:center;top:1rem;width:", "rem;", ""], getSize, getSize, getSize, function (p) {
  return p.device === 'mobile' && 'font-size: 12px;';
});
//# sourceMappingURL=styles.js.map